import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Prices', path: '/prices' },
    { name: 'Blog', path: '/blog' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 shadow-lg relative z-50">
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2 cursor-pointer">
            <div className="text-white font-bold text-2xl" style={{ fontFamily: '"Pacifico", serif' }}>
              Digital Experience Studio
            </div>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-white hover:text-cyan-300 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer ${
                  location.pathname === item.path ? 'text-cyan-300 border-b-2 border-cyan-300' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center space-x-3">
            <Link
              to="/consultation"
              className="bg-cyan-400 text-blue-900 px-6 py-2 rounded-full font-bold hover:bg-cyan-300 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Free Consultation
            </Link>
            <Link
              to="/quote"
              className="bg-white/20 backdrop-blur-sm text-white px-6 py-2 rounded-full font-bold hover:bg-white/30 transition-colors duration-300 whitespace-nowrap cursor-pointer border border-white/30"
            >
              Free Quote
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
